module.exports = ".setting-input{\r\n    width: 50px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin-dashboard/optimizer/advanced-settings-dialog/advanced-settings-dialog.component.css
// module id = ./src/app/admin-dashboard/optimizer/advanced-settings-dialog/advanced-settings-dialog.component.css
// module chunks = main